<template>
  <b-modal
    v-model="model"
    centered
    title="Add new user"
    modal-class="modal-bb-squared"
    hide-footer
  >
    <template slot="default">
      <AlertSlideUpDown :show="!!error">{{ error }}</AlertSlideUpDown>

      <form @submit.prevent="onSubmit">
        <FormItem
          invalid-message="Please enter first name"
          :state="$v.form.name.$dirty ? !$v.form.name.$error : null"
          required
        >
          <b-form-input
            v-model="form.name.first"
            :state="$v.form.name.$dirty ? !$v.form.name.$error : null"
            placeholder="First name"
          />
        </FormItem>

        <FormItem
          invalid-message="Please enter last name"
          :state="$v.form.name.$dirty ? !$v.form.name.$error : null"
          required
        >
          <b-form-input
            v-model="form.name.last"
            :state="$v.form.name.$dirty ? !$v.form.name.$error : null"
            placeholder="Last name"
          />
        </FormItem>

        <FormItem
          invalid-message="Please enter email"
          :state="$v.form.email.$dirty ? !$v.form.email.$error : null"
          required
        >
          <b-form-input
            v-model="form.email"
            :state="$v.form.email.$dirty ? !$v.form.email.$error : null"
            placeholder="Email address"
          />
        </FormItem>

        <p class="fs14 pb-20">
          An email will be sent with instructions on how to set a password
        </p>

        <button class="btn btn-lg w-100 mb-16" type="submit">
          <span v-if="!isSending">Create</span>
          <b-spinner v-else small />
        </button>
      </form>
    </template>
  </b-modal>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import modalMixin from '@/mixins/modal'
import FormItem from '@/components/form/FormItem/index'
import AlertSlideUpDown from '@/components/AlertSlideUpDown'

export default {
  name: 'UsersAddModal',
  components: {
    FormItem,
    AlertSlideUpDown
  },
  mixins: [modalMixin, validationMixin],
  props: {
    type: {
      type: String,
      default: 'startup'
    },
    profileKey: {
      type: String,
      required: true
    }
  },
  data: () => ({
    isSending: false,
    error: '',
    form: {
      name: {
        first: '',
        last: ''
      },
      email: ''
    }
  }),
  computed: {
    basePath() {
      return this.type === 'investor' ? 'investors' : 'companies'
    }
  },
  methods: {
    async onSubmit() {
      if (this.isSending) {
        return
      }

      this.$v.form.$touch()

      if (this.$v.form.$error) {
        return
      }

      this.isSending = true
      this.error = ''

      try {
        const uri = this.basePath + '/' + this.profileKey + '/managers'
        const { data } = await this.$axios.post(uri, this.form)

        this.$emit('add', data.user)

        this.model = false
        this.resetForm()
      } catch (err) {
        this.error = err.message
      }

      this.isSending = false
    },
    resetForm() {
      this.form.name.first = this.form.name.last = this.form.email = ''
      this.$v.form.$reset()
    }
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
      name: {
        first: {
          required
        },
        last: {
          required
        }
      }
    }
  }
}
</script>
